// extracted by mini-css-extract-plugin
export default {"mobileMenuMax":"1024px","contentWrapper":"contentWrapper-3RqEiS"};